import { updated } from "../actions";

const updateText = (todoId, currentText) => {
    return async (dispatch) => {
        const response = await fetch(`https://priyoserver.herokuapp.com/todos/${todoId}`, {
            method: "PATCH",
            body: JSON.stringify({
                text: currentText,
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8",
            },
        });
        const todo = await response.json();

        dispatch(updated(todo.id, todo.text));
    };
};

export default updateText;
